import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  ErrorFeedback,
  Fieldset,
  HintToggleButton,
  InputPassword,
  Legend,
} from '@paytrace/pt-skel/Component'
import { AppCtx } from '@paytrace/pt-skel/Context'
import PubSub from '@paytrace/pt-skel/Event/PubSub'
import Event from '../Event'
import BaseEvent from '@paytrace/pt-skel/Event'
import * as T from '../types'

interface Props {}

const self = Symbol('SwipeCard')

export function SwipeCard (props: Props) {
  const context = useContext(AppCtx)
  const [swipe, setSwipe] = useState('')
  const [isProcessing, setIsProcessing] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    PubSub.sub(self, Event.RUN_TRANSACTION_PREVIEW_RESPONSE, (json: T.TransactionPreviewResponse) => {
      if (json.status === 'success') {
        if (json.data?.card_info?.is_expired === true) {
          PubSub.pub(Event.NETWORK_ERROR, new Error('The swiped card is expired.'))
          setIsProcessing(false)
        } else {
          navigate('/swipetranx.pay', { state: { swipe, data: json.data } })
        }
      } else {
        setIsProcessing(false)
      }
    })
    PubSub.sub(self, Event.NETWORK_ERROR, (err: Error) => {
      if (err.message) {
        console.debug('clearing swipe field value')
        setSwipe('')
        setIsProcessing(false)
      }
    })

    return () => {
      PubSub.unsub(self)
    }
  }, [swipe, navigate])

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setIsProcessing(true)
    PubSub.pub('VALIDATION_ERROR::clear')
    PubSub.pub(BaseEvent.NETWORK_ERROR_CLEAR)
    PubSub.pub(
      Event.RUN_TRANSACTION_PREVIEW_REQUEST,
      { merchant_id: context.merchant, swipe }
    )

    return false
  }

  return (
    <>
      <div className='float-right'>
        <HintToggleButton />
        <a className='help-link' href="https://paytrace.atlassian.net/wiki/spaces/HD/pages/2025914860/Swipe+Card">Help</a>
      </div>
      <h1>Swipe Card</h1>
      <hr className='clear' />
      <form onSubmit={submit}>
      <Fieldset>
        <Legend title='Swipe the Card' />

        <InputPassword id="swipe"
          autoComplete='off'
          label='Swipe'
          hintText='Place the cursor in this field and swipe the card through the keyboard emulated card reader.'
          value={swipe}
          onChange={(e) => setSwipe(e.target.value)}
          required
          autoFocus
        />

        <div className='spacer'>
          <ErrorFeedback name='root' />
          <button className='form-btn' disabled={isProcessing}>
            {isProcessing ? 'Processing...' : 'Process'}
          </button>
        </div>
      </Fieldset>
    </form>
    </>
  )
}

export default SwipeCard
